import { render, staticRenderFns } from "./ModulesSingleScreen.vue?vue&type=template&id=6b001173&"
import script from "./ModulesSingleScreen.vue?vue&type=script&lang=js&"
export * from "./ModulesSingleScreen.vue?vue&type=script&lang=js&"
import style0 from "./ModulesSingleScreen.vue?vue&type=style&index=0&id=6b001173&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports